// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"2168e9de","453":"d1994899"}[chunkId] + ".chunk.js";
};